export const CATEGORY_LIST = [
	// 사회
	"뉴스",
	"사회",
	"문화",
	"교육",
	"직업",
	"생활",
	"연예",
	// 정치
	"정치",
	"외교",
	// 경제
	"경제",
	"금융",
	"산업",
	"부동산",
	// 과학
	"과학",
	"기술",
	// 의료
	"의료",
	"건강",
	// 환경
	"환경",
	"기후",
	// 법률
	"법",
	"제도",
	// 데이터
	"스포츠",
	"통계",
	// 역사
	"역사",
	"사건",
];


export const JOB_CATEGORY_LIST = [
	"학생",
	"무직/구직 중",
	"가정주부/돌봄",
	"공무원/공공기관",
	"군인/경찰/소방",
	"경영/관리/사무직",
	"연구/교육",
	"의학/보건/의료",
	"사회복지/상담",
	"법률/행정",
	"금융/보험/부동산",
	"IT/개발/데이터",
	"엔지니어/기술/제조",
	"건설/건축/토목",
	"운송/물류/운전",
	"서비스업(요식·숙박·미용 등)",
	"판매/유통/영업",
	"문화/예술/스포츠/엔터테인먼트",
	"언론/출판/방송/광고",
	"자영업/프리랜서/창업",
	"농업/임업/어업",
	"기타"
];

